import { css } from "@styled-system/css";
import { grid, flex } from "@styled-system/patterns";

export const multipleChoiceContainer = grid({
	gridTemplateColumns: {
		base: "12",
	},
	gap: "2",
	padding: "4",
});

export const multipleChoiceIconWrapper = flex({
	gridColumn: {
		base: "[span 1 / span 1]",
	},
	alignItems: "start",
	justifyContent: "center",
});

export const multipleChoiceContentWrapper = css({
	gridColumn: "[span 11 / span 11]",
	ml: "10",
});

export const multipleChoiceList = css({
	listStylePosition: "outside",
	pl: "4",
});

export const multipleChoiceListItem = css({
	pl: "10",
});
export const multipleChoiceWrongAnswer = css({
	color: "error.100!",
});
export const multipleChoiceCorrectAnswer = css({
	color: "success.100!",
});
